module.exports = "../images/fishing-lodge-2-6.jpg?v=7bc6cef";